import { tokenKeyMapping } from "@/dto/model.dto";

export const localKey: tokenKeyMapping = {
  accessToken: "core_access_token",
  refreshToken: "core_refresh_token",
};
export const localization = "localization";
export const localSidebarKey = "sidebar";
export const localPagination = "metaQuery";
export const localOffset = "offsetQuery";
export const localStateFilter = "stateQuery";
